import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { ChatbotConfig } from '@shared/index';
import { getContrastColorSafe } from '@shared-angular';

@Component({
  selector: 'app-bot-quickinfo',
  templateUrl: './bot-quickinfo.component.html',
  styleUrl: './bot-quickinfo.component.scss',
  imports: [NgStyle, NgTemplateOutlet]
})
export class BotQuickinfoComponent {
  public readonly botConfig = input.required<ChatbotConfig>();
  public readonly showIcon = input<boolean>(true);
  public readonly colorMode = input<boolean>(true);
  public readonly featuresOnly = input<boolean>(false);
  public readonly hideFeatures = input<boolean>(false);
  public getContrastColor = getContrastColorSafe;

}
